export const environment = {
  production: false,
  appVersion: 'v0.0.3 - 10/06/2026 16:19',
  apiUrl: 'https://apinautisvisiondev.digitalsync.com.br/api/',
};
